import { lazy } from 'react';
import type { BingoMarketingModalProps } from './BingoMarketingModal';

export type { BingoMarketingModalProps };

type BingoMarketingModalModule = typeof import('./BingoMarketingModal');

let modulePromise:
    | Promise<{ default: BingoMarketingModalModule['default'] }>
    | undefined;

export const preloadBingoMarketingModal = () => {
    modulePromise ??= import('./BingoMarketingModal').then((module) => ({
        default: module.default,
    }));

    return modulePromise;
};

export const LazyBingoMarketingModal = lazy(preloadBingoMarketingModal);
